/* External dependencies */
/* Internal dependencies */
import {
	createAllOfEntitySelector,
	createEntityByIdSelector,
} from "./factories";

/**
 * Returns all provisioners in the state.
 *
 * @function
 *
 * @param {Object} state Application state.
 *
 * @returns {Array} All provisioners.
 */
export const getProvisioners = createAllOfEntitySelector( "provisionerData" );

/**
 * Returns byId part of provisioners entities in the state.
 *
 * @function
 *
 * @param {Object} state Application state.
 *
 * @returns {Object} Provisioner entities by id.
 */
export const getProvisionersById = createEntityByIdSelector( "provisionerData" );
